export default __webpack_public_path__ + "static/media/ImageAyudaRegistro.9c4e949f.png";